// Базовый URL CRM. Маршруты admin/*, logistics/*, waypoint/* на основном домене
// закрыты (доступны только через CRM-хост под VPN), поэтому ссылки на них
// должны вести на crm-хост. Если переменная не задана (тестовые стенды),
// используем основной домен API.
export const CRM_BASE_URL = process.env.REACT_APP_CRM_BASE_URL || process.env.REACT_APP_API_BASE_URL;
